/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Vpn_Link_TextInputs */

const en_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get quick answers about Brave VPN`)
};

const id_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan jawaban cepat tentang Brave VPN`)
};

const ms_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan jawapan pantas tentang Brave VPN`)
};

const ca_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtingues respostes ràpides sobre la VPN de Brave`)
};

const cs_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získejte rychlé odpovědi o Brave VPN`)
};

const da_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få hurtige svar om Brave VPN`)
};

const de_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhalten Sie schnelle Antworten zu Brave VPN.`)
};

const et_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saa kiireid vastuseid Brave VPN-i kohta`)
};

const es_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén respuestas rápidas acerca de Brave VPN`)
};

const fr_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenir de l’aide concernant le VPN Brave`)
};

const hr_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobite brze odgovore o usluzi Brave VPN`)
};

const it_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevi risposte rapide su Brave VPN`)
};

const lv_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saņemiet ātras atbildes par Brave VPN`)
};

const lt_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaukite greitus atsakymus apie „Brave“ virtualųjį privatųjį tinklą`)
};

const hu_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyors válaszok a Brave VPN-ről`)
};

const nl_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krijg meer informatie over Brave VPN`)
};

const nb_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få kjappe svar om Brave VPN`)
};

const pl_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzyskaj szybkie odpowiedzi na temat Brave VPN`)
};

const pt_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenha respostas rápidas sobre a VPN Brave`)
};

const ro_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obține răspunsuri rapide despre Brave VPN`)
};

const sk_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získajte rýchle odpovede o Brave VPN`)
};

const sl_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pridobite hitre odgovore o storitvi Brave VPN`)
};

const fi_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanki nopeasti vastauksia Brave VPN:stä`)
};

const sv_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få snabba svar om Brave VPN`)
};

const vi_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tham khảo câu trả lời nhanh về Brave VPN`)
};

const tr_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN hakkında hızlı yanıtlar alın`)
};

const el_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Λάβετε γρήγορες απαντήσεις για το Brave VPN`)
};

const bg_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получи бързи отговори за Brave VPN`)
};

const ru_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получите быстрые ответы о Brave VPN`)
};

const sr_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кратки одговори на питања о Brave VPN-у`)
};

const uk_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримайте швидкі відповіді про Brave VPN`)
};

const ka_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მიიღეთ სწრაფი პასუხები Brave VPN-ის შესახებ`)
};

const hi_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्रेव VPN के बारे में जानकारी पाएं`)
};

const th_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับคำตอบอย่างรวดเร็วเกี่ยวกับ Brave VPN`)
};

const ko_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN에 관한 자주 묻는 질문`)
};

const zh_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取有关 Brave VPN 的快速解答`)
};

const zh_tw_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獲取有關 Brave VPN 的快速解答`)
};

const ja_brave_vpn_link_text = /** @type {(inputs: Brave_Vpn_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPNに関するクイックアンサー`)
};

/**
* | output |
* | --- |
* | "Get quick answers about Brave VPN" |
*
* @param {Brave_Vpn_Link_TextInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const brave_vpn_link_text = /** @type {((inputs?: Brave_Vpn_Link_TextInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Vpn_Link_TextInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brave_vpn_link_text(inputs)
	if (locale === "ms") return ms_brave_vpn_link_text(inputs)
	if (locale === "ca") return ca_brave_vpn_link_text(inputs)
	if (locale === "cs") return cs_brave_vpn_link_text(inputs)
	if (locale === "da") return da_brave_vpn_link_text(inputs)
	if (locale === "de") return de_brave_vpn_link_text(inputs)
	if (locale === "et") return et_brave_vpn_link_text(inputs)
	if (locale === "es") return es_brave_vpn_link_text(inputs)
	if (locale === "fr") return fr_brave_vpn_link_text(inputs)
	if (locale === "hr") return hr_brave_vpn_link_text(inputs)
	if (locale === "it") return it_brave_vpn_link_text(inputs)
	if (locale === "lv") return lv_brave_vpn_link_text(inputs)
	if (locale === "lt") return lt_brave_vpn_link_text(inputs)
	if (locale === "hu") return hu_brave_vpn_link_text(inputs)
	if (locale === "nl") return nl_brave_vpn_link_text(inputs)
	if (locale === "nb") return nb_brave_vpn_link_text(inputs)
	if (locale === "pl") return pl_brave_vpn_link_text(inputs)
	if (locale === "pt") return pt_brave_vpn_link_text(inputs)
	if (locale === "ro") return ro_brave_vpn_link_text(inputs)
	if (locale === "sk") return sk_brave_vpn_link_text(inputs)
	if (locale === "sl") return sl_brave_vpn_link_text(inputs)
	if (locale === "fi") return fi_brave_vpn_link_text(inputs)
	if (locale === "sv") return sv_brave_vpn_link_text(inputs)
	if (locale === "vi") return vi_brave_vpn_link_text(inputs)
	if (locale === "tr") return tr_brave_vpn_link_text(inputs)
	if (locale === "el") return el_brave_vpn_link_text(inputs)
	if (locale === "bg") return bg_brave_vpn_link_text(inputs)
	if (locale === "ru") return ru_brave_vpn_link_text(inputs)
	if (locale === "sr") return sr_brave_vpn_link_text(inputs)
	if (locale === "uk") return uk_brave_vpn_link_text(inputs)
	if (locale === "ka") return ka_brave_vpn_link_text(inputs)
	if (locale === "hi") return hi_brave_vpn_link_text(inputs)
	if (locale === "th") return th_brave_vpn_link_text(inputs)
	if (locale === "ko") return ko_brave_vpn_link_text(inputs)
	if (locale === "zh") return zh_brave_vpn_link_text(inputs)
	if (locale === "zh-tw") return zh_tw_brave_vpn_link_text(inputs)
	if (locale === "ja") return ja_brave_vpn_link_text(inputs)
	return en_brave_vpn_link_text(inputs)
});